export default {
      id: "i-service-indexes-usage",
      viewBox: "0 0 136 136",
      url: __webpack_public_path__ + "img/sprite.svg#i-service-indexes",
      toString: function () {
        return this.url;
      }
    }